import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import BizSelect from "../views/components/BizList/BizList";
export default {
  name: 'Index',
  components: {
    BizSelect: BizSelect
  },
  data: function data() {
    return {
      defaultMenu: '/dashboard'
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['name'])), {}, {
    key: function key() {
      return this.$route.fullPath;
    }
  }),
  watch: {
    $route: {
      handler: function handler(to, from) {
        if (this.$route.matched[0].path !== '') {
          this.defaultMenu = this.$route.matched[0].path;
        } else {
          this.defaultMenu = this.$route.matched[1].path;
        }
      },
      immediate: true // 第一次就执行
    }
  },
  created: function created() {
    if (this.$route.matched[0].path !== '') {
      this.defaultMenu = this.$route.matched[0].path;
    } else {
      this.defaultMenu = this.$route.matched[1].path;
    }
  },
  methods: {
    logout: function () {
      var _logout = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.dispatch('user/logout');
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function logout() {
        return _logout.apply(this, arguments);
      }
      return logout;
    }()
  }
};